import { IconChevronLeft, IconChevronRight } from '@tvg/fuse-icons';
import { SrOnly } from '@tvg/fuse-utils';
import PropTypes from 'prop-types';
import React from 'react';
import StyledButton from './styled-button-chevron';
import { NEXT_PAGE, PREVIOUS_PAGE } from './utils';

const { useCallback } = React;

const CHEVRON_LEFT_ICON = <IconChevronLeft />;
const CHEVRON_RIGHT_ICON = <IconChevronRight />;

const propTypes = {
	label: PropTypes.string.isRequired,
	currentPage: PropTypes.number.isRequired,
	numberOfPages: PropTypes.number.isRequired,
	callback: PropTypes.func,
	seoHref: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.bool
	]),
};

const defaultProps = {
	callback: undefined,
	seoHref: false
};

function ChevronButton({ label, currentPage, numberOfPages, callback, seoHref }) {
	const chevronIcon = label === PREVIOUS_PAGE ? CHEVRON_LEFT_ICON : CHEVRON_RIGHT_ICON;
	const isFirst = label === PREVIOUS_PAGE && currentPage === 1;
	const isLast = label === NEXT_PAGE && currentPage === numberOfPages;

	const onClickHandler = useCallback(
		(event) => {
			if(seoHref) event.preventDefault();
			if (callback) {
				const page = label === NEXT_PAGE ? currentPage + 1 : currentPage - 1;
				callback(event, page);
			}
		},
		[callback, label, currentPage],
	);

	return (
		<StyledButton
			icon={chevronIcon}
			onClick={onClickHandler}
			fullWidth={false}
			variant="tertiary"
			disabled={isFirst || isLast}
			href={seoHref}
		>
			<SrOnly>{label}</SrOnly>
		</StyledButton>
	);
}

ChevronButton.propTypes = propTypes;
ChevronButton.defaultProps = defaultProps;
ChevronButton.displayName = 'ChevronButton';

export { ChevronButton };

export default ChevronButton;
